import React from 'react';
import { LuxuryHomesDetails } from '@components';
import './style.scss';

const LuxuryHomesDetailsPage: React.FC = () => {
  return (
    <div className="luxury-homes-details-page">
      <LuxuryHomesDetails />
    </div>
  );
};

export default LuxuryHomesDetailsPage; 